import { render, staticRenderFns } from "./filter-table.component.vue?vue&type=template&id=5147089a&scoped=true"
import script from "./filter-table.component.vue?vue&type=script&lang=js"
export * from "./filter-table.component.vue?vue&type=script&lang=js"
import style0 from "./filter-table.component.vue?vue&type=style&index=0&id=5147089a&prod&lang=scss&scoped=true"
import style1 from "./filter-table.component.vue?vue&type=style&index=1&id=5147089a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5147089a",
  null
  
)

export default component.exports